var map = {
	"./algoritma-fyp-tiktok-malaysia.json": [
		76154,
		1006
	],
	"./algoritma-tiktok-cara-masuk-fyp.json": [
		30822,
		686
	],
	"./apa-itu-smm-panel.json": [
		50303,
		7043
	],
	"./beli-followers-instagram-selamat-ke.json": [
		15005,
		6097
	],
	"./beli-followers-tiktok-malaysia.json": [
		17058,
		3048
	],
	"./beli-followers-twitter-x-malaysia.json": [
		66042,
		8686
	],
	"./beli-subscribers-telegram-malaysia.json": [
		65073,
		1275
	],
	"./beli-subscribers-youtube-selamat-ke.json": [
		23442,
		7130
	],
	"./beli-views-tiktok-berbaloi-ke.json": [
		46059,
		8047
	],
	"./berapa-gaji-tiktoker-malaysia.json": [
		56282,
		4378
	],
	"./cara-buat-bio-instagram-menarik.json": [
		4951,
		3023
	],
	"./cara-buat-duit-dengan-tiktok.json": [
		20109,
		7863
	],
	"./cara-dapat-1000-subscribers-youtube.json": [
		51655,
		9691
	],
	"./cara-dapat-google-review-bisnes.json": [
		25821,
		689
	],
	"./cara-dapatkan-brand-deal-pertama.json": [
		29689,
		4407
	],
	"./cara-guna-engagement-real-my-fyp-tiktok.json": [
		31229,
		7953
	],
	"./cara-guna-threads-untuk-bisnes-malaysia.json": [
		22811,
		5575
	],
	"./cara-jadi-influencer-malaysia.json": [
		81429,
		6805
	],
	"./cara-jadi-reseller-smm.json": [
		60708,
		4854
	],
	"./cara-jadi-ugc-creator-malaysia.json": [
		63000,
		4414
	],
	"./cara-jual-di-tiktok-live.json": [
		75819,
		6317
	],
	"./cara-kira-engagement-rate.json": [
		9987,
		8267
	],
	"./cara-live-shopee-ramai-penonton.json": [
		40183,
		475
	],
	"./cara-live-tiktok-shop-ramai-penonton.json": [
		14062,
		8696
	],
	"./cara-live-tiktok-syarat-1000-followers.json": [
		72217,
		5739
	],
	"./cara-monetize-youtube-malaysia.json": [
		23252,
		9482
	],
	"./cara-naik-ranking-google-maps-malaysia.json": [
		53571,
		257
	],
	"./cara-naikkan-engagement-instagram.json": [
		32789,
		2993
	],
	"./cara-naikkan-followers-instagram.json": [
		72355,
		5093
	],
	"./cara-naikkan-followers-threads.json": [
		30194,
		3972
	],
	"./cara-naikkan-followers-tiktok-malaysia.json": [
		6477,
		7595
	],
	"./cara-naikkan-jualan-shopee-malaysia.json": [
		77931,
		6131
	],
	"./cara-naikkan-likes-facebook-page.json": [
		87856,
		8082
	],
	"./cara-naikkan-streams-spotify.json": [
		99291,
		1269
	],
	"./cara-naikkan-viewers-shopee-live.json": [
		18752,
		5234
	],
	"./cara-tambah-likes-facebook.json": [
		13242,
		5576
	],
	"./cara-tukar-akaun-bisnes-instagram.json": [
		29223,
		8567
	],
	"./cara-viral-di-instagram-reels.json": [
		50122,
		6350
	],
	"./cara-viral-di-tiktok.json": [
		92760,
		3034
	],
	"./content-calendar-sosial-media.json": [
		36156,
		8468
	],
	"./engagement-rate-vs-followers.json": [
		82895,
		7293
	],
	"./facebook-marketing-bisnes-malaysia.json": [
		6917,
		863
	],
	"./harga-beli-followers-instagram-malaysia.json": [
		16118,
		2658
	],
	"./hashtag-malaysia-terbaik-ig-tiktok.json": [
		77362,
		2340
	],
	"./instagram-reels-vs-tiktok.json": [
		43282,
		1062
	],
	"./kenapa-engagement-malaysia-lebih-berkesan.json": [
		61674,
		4494
	],
	"./kenapa-live-tiktok-takde-orang-tengok.json": [
		10922,
		8190
	],
	"./kenapa-reach-facebook-page-jatuh.json": [
		31971,
		6861
	],
	"./kos-marketing-influencer-malaysia.json": [
		48597,
		1053
	],
	"./marketing-sosial-media-untuk-bisnes.json": [
		10107,
		2803
	],
	"./panduan-pilih-pakej-real-my-ikut-bajet.json": [
		68758,
		1716
	],
	"./panel-smm-murah-malaysia.json": [
		44393,
		3743
	],
	"./real-engagement-vs-bot-followers-malaysia.json": [
		57985,
		9917
	],
	"./shadowban-tiktok-instagram-cara-fix.json": [
		79406,
		4558
	],
	"./smm-panel-terbaik-malaysia-2026.json": [
		69757,
		8045
	],
	"./strategi-grow-instagram-malaysia-2026.json": [
		66548,
		2160
	],
	"./strategi-marketing-raya-sosial-media.json": [
		4736,
		4806
	],
	"./syarat-1000-followers-tiktok-live.json": [
		25175,
		9619
	],
	"./tiktok-shop-malaysia-panduan-seller.json": [
		99200,
		4280
	],
	"./waktu-terbaik-post-instagram-tiktok.json": [
		63823,
		7987
	],
	"./waktu-terbaik-post-tiktok-malaysia.json": [
		35836,
		1046
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1586;
module.exports = webpackAsyncContext;